module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_L3-489ffddd00bb2d687eb5a59d0277ee62.png";